import { Moon, Sun } from 'lucide-react'

import { ActionInfo } from '@krp/ui-kit'

import { useAppDispatch, useAppSelector } from './hooks'
import { resolveTheme, selectTheme, themeChosen } from './theme'

/**
 * Один переключатель «светлая ↔ тёмная». Состояние видно не только цветом:
 * положение ползунка, значок солнца или луны и подпись у кнопки. Пока человек
 * не выбирал, показана тема по времени суток; нажатие фиксирует выбор за этим
 * устройством.
 */
export function ThemeSwitch() {
  const choice = useAppSelector(selectTheme)
  const dispatch = useAppDispatch()
  const theme = resolveTheme(choice)
  const dark = theme === 'dark'
  const label = dark ? 'Тёмная тема. Включить светлую' : 'Светлая тема. Включить тёмную'
  return (
    <div className="shell-theme" role="group" aria-label="Тема оформления">
      <ActionInfo id="shell.theme" layout="sibling">
        <button
          type="button"
          role="switch"
          aria-checked={dark}
          aria-label={label}
          title={label}
          className="shell-theme__switch"
          onClick={() => dispatch(themeChosen(dark ? 'light' : 'dark'))}
        >
          <span className="shell-theme__thumb" aria-hidden="true">
            {dark ? <Moon size={12} /> : <Sun size={12} />}
          </span>
        </button>
      </ActionInfo>
    </div>
  )
}
